export default __webpack_public_path__ + "static/media/geology-neptune.d1247e41.png";